import React, { useState, useEffect } from 'react'
import { Button, Select } from 'antd'
import { useTranslation } from 'react-i18next'
import AdsFiltersPanelHolder from '../styles/adsFiltersPanelStyle'
import { DYNAMIC_FILTER_VALUE } from '../../../../services/contents'

const { Option } = Select

const AdsFiltersPanel = ({ filters, onApply, isSuperUser = false }) => {
  const { t } = useTranslation()
  const [draft, setDraft] = useState(filters)

  useEffect(() => {
    setDraft(filters)
  }, [filters])

  const setField = (field) => (value) => {
    setDraft((prev) => ({ ...prev, [field]: value }))
  }

  return (
    <AdsFiltersPanelHolder>
      <div className="field">
        <label>{t('Type')}</label>
        <Select
          value={draft.type || undefined}
          onChange={setField('type')}
          placeholder={t('Ad type')}
          allowClear
        >
          <Option value="image">{t('Image')}</Option>
          <Option value="video">{t('Video')}</Option>
          {/* Only super users can create dynamic ads, so only they get the option
              to filter by them. */}
          {isSuperUser && (
            <Option value={DYNAMIC_FILTER_VALUE}>{t('Dynamic Creative Optimization (DCO)')}</Option>
          )}
        </Select>
      </div>

      <Button
        type="primary"
        className="apply-button"
        onClick={() => onApply(draft)}
      >
        {t('Apply')}
      </Button>
    </AdsFiltersPanelHolder>
  )
}

export default AdsFiltersPanel
